import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll, ScrollToTop } from "@/components/common/SmoothScroll";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CookieConsent } from "@/components/layout/CookieConsent";

import Home from "@/pages/Home";
import Groupe from "@/pages/Groupe";
import Strategie from "@/pages/Strategie";
import Metiers from "@/pages/Metiers";
import Acquisitions from "@/pages/Acquisitions";
import AcquisitionSector from "@/pages/AcquisitionSector";
import Ceder from "@/pages/Ceder";
import Societes from "@/pages/Societes";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function SiteLayout() {
  return (
    <>
      <Header />
      <main><Outlet /></main>
      <Footer />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App grain min-h-screen bg-[#07080B]">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <ScrollToTop />
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/groupe" element={<Groupe />} />
                <Route path="/strategie" element={<Strategie />} />
                <Route path="/metiers" element={<Metiers />} />
                <Route path="/acquisitions" element={<Acquisitions />} />
                <Route path="/acquisitions/:slug" element={<AcquisitionSector />} />
                <Route path="/ceder-votre-entreprise" element={<Ceder />} />
                <Route path="/societes" element={<Societes />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mentions-legales" element={<Legal type="mentions" />} />
                <Route path="/confidentialite" element={<Legal type="confidentialite" />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </SmoothScroll>
          <Toaster theme="dark" position="bottom-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
